import { useCallback, useMemo } from 'react';

import { chartThemeTokens } from 'design-system';

import { useRegularOptionsWithAppearance } from '@/features/charts/hooks/options/useRegularOptions';
import usePrefersReducedMotion from '@/features/charts/hooks/usePrefersReducedMotion';
import { withSpotSeriesAppearance } from '@/features/charts/lib/applyChartSeriesAppearance';
import { createChartAppearance } from '@/features/charts/theme/chartAppearance';
import type {
  ExtendedOptions,
  ExtendedSeriesOptionsType
} from '@/features/charts/types/highcharts';

const useSpotOptions = (height?: number, isDhChart = false) => {
  const mode = 'regular' as const;
  const appearance = useMemo(() => createChartAppearance(chartThemeTokens, mode), [mode]);
  const prefersReducedMotion = usePrefersReducedMotion();
  const { createOptions: createRegularOptions } = useRegularOptionsWithAppearance(
    height,
    isDhChart,
    appearance,
    prefersReducedMotion
  );

  const createOptions = useCallback(
    (chartSeries: ExtendedSeriesOptionsType[], hiddenSeriesIds: string[] = []): ExtendedOptions => {
      const coloredSeries = chartSeries.map(series => withSpotSeriesAppearance(series, appearance));
      return createRegularOptions(coloredSeries, hiddenSeriesIds);
    },
    [appearance, createRegularOptions]
  );

  return { createOptions };
};

export default useSpotOptions;
